import React, {FC, memo} from 'react';

import {ProjectsTableHeaderNew as ProjectsTableHeader} from '../../components/ProjectsTableUser';
import {TeamProjectPaginatedList} from './../../components/PaginatedList/PaginatedProjectLists';

type ProjectsSectionProps = {entityName: string; readOnly: boolean};

const ProjectsSectionComp: FC<ProjectsSectionProps> = ({
  entityName,
  readOnly,
}) => {
  return (
    <>
      <ProjectsTableHeader entityName={entityName} readOnly={readOnly} />
      <TeamProjectPaginatedList entityName={entityName} isReadOnly={readOnly} />
    </>
  );
};

export const ProjectsSection = memo(ProjectsSectionComp);
